export type BdrValuationCalendarsActions =
  | BdrValuationCalendarsBlackoutDatesRequested
  | BdrValuationCalendarsBlackoutDatesReceived
  | BdrValuationCalendarsBlackoutDatesFailed
  | BdrValuationCalendarsBlackoutDatesTimeouted;

export type BdrValuationCalendarsBlackoutDatesRequested = ReturnType<
  typeof bdrValuationCalendarsBlackoutDatesRequested
>;

export function bdrValuationCalendarsBlackoutDatesRequested(calendarCodes: string[]) {
  return {
    type: 'VALUATION_CALENDARS_BLACKOUT_DATES_REQUESTED' as const,
    calendarCodes,
  };
}

export type BdrValuationCalendarsBlackoutDatesReceived = ReturnType<typeof bdrValuationCalendarsBlackoutDatesReceived>;
export function bdrValuationCalendarsBlackoutDatesReceived(calendars: IDictionary<string[]>) {
  return {
    type: 'VALUATION_CALENDARS_BLACKOUT_DATES_RECEIVED' as const,
    calendars,
  };
}

export type BdrValuationCalendarsBlackoutDatesFailed = ReturnType<typeof bdrValuationCalendarsBlackoutDatesFailed>;

export function bdrValuationCalendarsBlackoutDatesFailed() {
  return {
    type: 'VALUATION_CALENDARS_BLACKOUT_DATES_FAILED' as const,
  };
}

export type BdrValuationCalendarsBlackoutDatesTimeouted = ReturnType<
  typeof bdrValuationCalendarsBlackoutDatesTimeouted
>;

export function bdrValuationCalendarsBlackoutDatesTimeouted() {
  return {
    type: 'VALUATION_CALENDARS_BLACKOUT_DATES_TIMEOUTED' as const,
  };
}
